import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { ConsequenceModifyComponent } from "./consequence-modify/consequence-modify.component";
import { DataService_HallSweepConsequence } from "./shared/data.service";

@Component({
	selector: "app-consequence-maintenance",
	templateUrl: "./consequence-maintenance.component.html",
	styleUrls: ["./consequence-maintenance.component.css"],
})
export class ConsequenceMaintenanceComponent implements OnInit {
	constructor(
		private userService: UserService,
		private consequenceService: DataService_HallSweepConsequence,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadConsequence();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedConsequence: any;
	lstConsequence: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ConsequenceTrigger", header: "Trigger afte occurences" },
		{ field: "ConsequenceDesc", header: "Description" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadConsequence() {
		this.errorMessage = "";
		this.loading = true;

		var result = this.consequenceService.ConsequenceSelectList();
		result.subscribe(
			(response) => {
				this.lstConsequence = response;

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstConsequence.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadConsequence();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(ConsequenceModifyComponent, {
			header: "Add Consequence",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				EditMode: false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadConsequence();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedConsequence == undefined) {
			this.errorMessage = "Select a Consequence to edit";
			return;
		}

		var ref = this.dialogService.open(ConsequenceModifyComponent, {
			header: "Edit Consequence",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				EditMode: true,
				ConsequenceID: this.SelectedConsequence.ConsequenceID,
				ConsequenceDesc: this.SelectedConsequence.ConsequenceDesc,
				ConsequenceTrigger: this.SelectedConsequence.ConsequenceTrigger,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadConsequence();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedConsequence == undefined) {
			this.errorMessage = "Select a Consequence to toggle";
			return;
		}

		//Call SP
		var changeTo = this.SelectedConsequence.Active == true ? 0 : 1;

		var result = this.consequenceService.ConsequenceToggle(this.SelectedConsequence.ConsequenceID, changeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadConsequence();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (changeTo == 1 ? "activate" : "deactivate") + " the Consequence",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedConsequence == undefined) {
			this.errorMessage = "Select a Consequence to delete";
			return;
		}

		//Call SP
		this.CheckCanDelete();
	}

	CheckCanDelete() {
		var result = this.consequenceService.ConsequenceInUse(this.SelectedConsequence.ConsequenceID);
		result.subscribe(
			(response) => {
				if (response) {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"Cannot delete consequences that have been used in transactions. Delete Hall Sweep transactions before deleting this consequence.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.FinishDelete();
				}
			},
			(error) => {}
		);
	}

	FinishDelete() {
		var result = this.consequenceService.ConsequenceDelete(this.SelectedConsequence.ConsequenceID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadConsequence();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Delete the Consequence",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
		this.SelectedConsequence = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		this.SelectedConsequence = null;
	}
	onRowDblClick(Consequence) {
		this.errorMessage = "";
		this.SelectedConsequence = Consequence;
		this.onEdit();
	}
	////////////////////////////////////////////
}
